var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRocketShip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 119 119",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m47.449 10.02 1.404-1.415M55.007 2.403 56.4 1M56.4 10.02l-1.393-1.415M48.853 2.403 47.449 1",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m49.461 50.361 14.637 14.752",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M90.114 41.811c4.083-2.9 5.06-8.587 2.182-12.702-2.878-4.115-8.52-5.099-12.603-2.199-4.083 2.9-5.06 8.588-2.182 12.702 2.878 4.115 8.52 5.1 12.603 2.199Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M57.839 73.073c13.35-1.485 27.74-8.478 39.592-20.423 15.292-15.413 22.406-35.07 20.159-51.236C101.55-.851 82.046 6.319 66.754 21.73 54.89 33.688 47.964 48.192 46.489 61.635l11.35 11.438Z",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M66.04 22.463c-9.243 3.526-19.164 10.035-28.092 19.044a96.309 96.309 0 0 0-5.475 6.002l8.693 8.761M63.057 78.332l8.787 8.856a96.149 96.149 0 0 0 5.955-5.519c8.88-8.95 15.327-18.89 18.837-28.16",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m29.08 81.316-2.164 2.182M42.699 67.59l-9.664 9.74M36.755 82.885l-8.611 8.679M46.15 73.416l-5.826 5.872M44.22 84.652l-8.073 8.137M51.93 76.894l-3.58 3.609M1 70.232a10.04 10.04 0 0 1 1.977-2.83c3.908-3.939 10.261-3.95 14.169 0a10.14 10.14 0 0 1 2.539 9.94M10.337 83.426a5.479 5.479 0 0 1-1.896-1.25 5.57 5.57 0 0 1-.912-6.615M42.243 114.428a5.458 5.458 0 0 1-5.09-1.486 5.524 5.524 0 0 1-1.369-2.299M42.945 102.306a8.43 8.43 0 0 1 10.483 1.202c3.31 3.338 3.31 8.75 0 12.087a8.385 8.385 0 0 1-4.727 2.406M20.738 72.178a7.022 7.022 0 0 1 7.909.542M45.951 91.057a7.599 7.599 0 0 1 .422 9.433l-.246.319M29.373 101.292a8.59 8.59 0 0 1-9.466-1.875c-2.574-2.594-3.182-6.403-1.837-9.587",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.242 99.816h1.977M101.924 99.816h1.978M97.572 106.196v-1.993M97.572 95.43v-1.993",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m112.501 62.53-.386-.39M118 68.073l-.386-.39M112.501 67.684l-.386.389M118 62.14l-.386.39",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M13.636 42.332c1.622 0 2.937-1.325 2.937-2.96s-1.315-2.96-2.937-2.96c-1.622 0-2.937 1.325-2.937 2.96s1.315 2.96 2.937 2.96ZM66.344 103.26a1.08 1.08 0 0 0 1.077-1.085 1.08 1.08 0 0 0-1.077-1.085 1.08 1.08 0 0 0-1.076 1.085 1.08 1.08 0 0 0 1.076 1.085Z",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgRocketShip;